export const automaticActionKey = (batchId, result) =>
  `${batchId}:${result.id}:${result.next_action?.type}:${result.talkvia_authorization?.id || ''}`;

export const canContinueAutomatically = result =>
  !['awaiting', 'cancelled'].includes(result.status) &&
  (result.status !== 'processing' ||
    result.next_action?.type === 'query_status') &&
  ['simulation', 'offer_query', 'authorization_sync', 'query_status'].includes(
    result.next_action?.type
  ) &&
  result.next_action?.available !== false &&
  !(result.next_action?.required_fields || []).length;

export const journeySummary = results => ({
  offers: results.filter(result => result.offers?.length).length,
  pending: results.filter(result => result.status === 'authorization_required')
    .length,
  processing: results.filter(result =>
    ['awaiting', 'processing'].includes(result.status)
  ).length,
  errors: results.filter(result =>
    ['error', 'provider_error', 'timeout', 'credentials_missing'].includes(
      result.status
    )
  ).length,
});
